/**
 * IWAO Banner Slideshow
 * Handles fade transitions between slides.
 * Ken Burns animation is handled entirely by CSS.
 */
(function () {
  'use strict';

  function initSlideshow() {
    var container = document.querySelector('.banner__slideshow[data-slide-count]');
    if (!container) return;

    var slides = container.querySelectorAll('.banner__slide');
    if (slides.length < 2) return; // Single slide = Ken Burns only, no cycling

    var duration = (parseInt(container.dataset.slideDuration, 10) || 7) * 1000;
    var current = 0;

    function nextSlide() {
      var prev = slides[current];
      prev.classList.remove('banner__slide--active');
      prev.classList.add('banner__slide--leaving');

      current = (current + 1) % slides.length;
      slides[current].classList.add('banner__slide--active');

      // Remove leaving class after fade-out (1.4s) completes
      setTimeout(function () {
        prev.classList.remove('banner__slide--leaving');
      }, 1500);
    }

    setInterval(nextSlide, duration);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSlideshow);
  } else {
    initSlideshow();
  }
})();
